// --------------------------
// IMPORTS
// --------------------------
import { Row, Col, Form, message, DatePicker } from "antd";
import { useDispatch, useSelector } from "react-redux";
import TopContainerHeader from "../../components/molecules/TopComponentHeader";
import { useEffect, useState } from "react";
import {
  getExpenseAnnualRestrictionThunk,
  enableExpenseAnnualRestrictionThunk,
  disableExpenseAnnualRestrictionThunk,
} from "../../store/thunks/settingsThunk";
import dayjs from "dayjs";
import CustomLoader from "../../utils/CustomLoader";
import SubmitButton from "../../components/atoms/Buttons/SubmitButton";
import SettingsPanel from "../../components/molecules/SettingsPanel";

// --------------------------
// MAIN COMPONENT
// --------------------------
export default function Settings() {
  //Dispatch + Custom Hooks
  const dispatch = useDispatch();
  const { RangePicker } = DatePicker;

  // --------------------------
  // REDUX STATE
  // --------------------------
  const storeRole = useSelector((state) => state.auth.role);
  const storeLIUId = useSelector((state) => state.auth.lIUId);

  // --------------------------
  // LOCAL STATES
  // --------------------------
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [blockedDate, setBlockedDate] = useState(null);

  // --------------------------
  // API CALLS
  // --------------------------
  const expCal = () => {
    //setShowLoader(true);

    const payload = {
      role: storeRole,
      lIUId: storeLIUId,
    };

    // dispatch(getExpenseAnnualRestrictionThunk(payload))
    //   .unwrap()
    //   .then((response) => {
    //     if (response?.expCalRes) {
    //       const data = response.expCalRes;
    //       setBlockedDate(data);
    //       if (
    //         data.status === process.env.REACT_APP_BLOCK_STATUS &&
    //         data.blockedFrom &&
    //         data.blockedTo
    //       ) {
    //         const currentYear = dayjs().year();

    //         const start = dayjs(
    //           `${currentYear}-${data.blockedFrom}`,
    //           "YYYY-MM-DD",
    //         );

    //         const end = dayjs(`${currentYear}-${data.blockedTo}`, "YYYY-MM-DD");

    //         setSelectedDate([start, end]);
    //       } else {
    //         setSelectedDate([]);
    //       }
    //     } else {
    //       setBlockedDate(null);
    //       setSelectedDate([]);
    //     }
    //   })
    //   .finally(() => setShowLoader(false));
  };

  useEffect(() => {
    expCal();
  }, []);

  useEffect(() => {
    if (
      blockedDate &&
      blockedDate.status === process.env.REACT_APP_BLOCK_STATUS &&
      blockedDate.blockedFrom &&
      blockedDate.blockedTo
    ) {
      const currentYear = dayjs().year();

      const start = dayjs(
        `${currentYear}-${blockedDate.blockedFrom}`,
        "YYYY-MM-DD",
      );

      const end = dayjs(
        `${currentYear}-${blockedDate.blockedTo}`,
        "YYYY-MM-DD",
      );

      setSelectedDate([start, end]);
    } else {
      setSelectedDate([]);
    }
  }, [blockedDate]);

  // --------------------------
  // HANDLERS
  // --------------------------

  const handleEnableAnnualRestriction = () => {
    if (
      !selectedDate ||
      !Array.isArray(selectedDate) ||
      selectedDate.length !== 2 ||
      !selectedDate[0] ||
      !selectedDate[1]
    ) {
      message.warning("Please select a valid date range.");
      return;
    }

    const [startDate, endDate] = selectedDate;

    setShowLoader(true);
    const payload = {
      blockedFrom: startDate.format("MM-DD"),
      blockedTo: endDate.format("MM-DD"),
      historySource: "backend",
      historyAction: "block",
      historyUserID: storeLIUId,
      status: process.env.REACT_APP_BLOCK_STATUS,
    };
    // dispatch(enableExpenseAnnualRestrictionThunk(payload))
    //   .unwrap()
    //   .then((response) => {
    //     if (response) {
    //       message.success("Annual restriction enabled successfully.");
    //       setBlockedDate({
    //         ...payload,
    //         _id: response?._id || blockedDate?._id,
    //       });
    //       setSelectedDate([]);
    //     }
    //   })
    //   .catch(() => {
    //     message.error("Failed to enable annual restriction.");
    //   })
    //   .finally(() => setShowLoader(false));
  };

  const handleDisableAnnualRestriction = () => {
    // Validate existing restriction
    if (!blockedDate || !blockedDate.blockedFrom || !blockedDate.blockedTo) {
      message.warning("No active annual restriction found.");
      return;
    }
    setShowLoader(true);

    const payload = {
      blockedFrom: blockedDate.blockedFrom,
      blockedTo: blockedDate.blockedTo,
      historySource: "backend",
      historyAction: "unblock",
      historyUserID: storeLIUId,
      status: process.env.REACT_APP_UNBLOCK_STATUS,
    };

    // dispatch(disableExpenseAnnualRestrictionThunk(payload))
    //   .unwrap()
    //   .then((response) => {
    //     if (response === process.env.REACT_APP_UNBLOCK_STATUS || response) {
    //       message.success("Annual restriction disabled successfully.");
    //       setBlockedDate(null);
    //       setSelectedDate([]);
    //     }
    //   })
    //   .catch(() => {
    //     message.error("Failed to disable annual restriction.");
    //   })
    //   .finally(() => setShowLoader(false));
  };

  // --------------------------
  // JSX RETURN
  // --------------------------
  return (
    <div className="container">
      <div className="bgi-no-repeat card-stretch gutter-b rounded-lg p-0">
        <TopContainerHeader
          sectionNameClass="col-lg-7 text-left commonTitleText"
          sectionTitle="Settings"
          hasSectionButton={
            storeRole === process.env.REACT_APP_SROLE ? true : false
          }
          hasSearch={false}
          addNewButtonClassName="btn mx-auto px-5 py-2 defaultbutton rounded-lg"
          name="Import bulk data"
          onButtonClick={() => setIsAddModalOpen(true)}
          addFormModalOpen={isAddModalOpen}
          addFormSetIsModalOpen={setIsAddModalOpen}
          addFormModalShowLoader={setShowLoader}
        />
        {showLoader ? (
          <CustomLoader showLoader={showLoader} />
        ) : (
          <div className="settings-wrapper">
            {/* Annual Expense Submission Restriction */}
            <SettingsPanel title="Annual Expense Submission Restriction">
              <Form layout="vertical">
                <Row gutter={[16, 16]} align="bottom">
                  <Col sm={8}>
                    <Form.Item label="" className="m-0">
                      <RangePicker
                        value={selectedDate}
                        onChange={(dates) => setSelectedDate(dates || [])}
                      />
                    </Form.Item>
                  </Col>

                  {blockedDate?.status ===
                  process.env.REACT_APP_BLOCK_STATUS ? (
                    <Col sm={"auto"}>
                      <Form.Item className="m-0 cusHeight38">
                        <SubmitButton
                          ky="unblock"
                          type="danger"
                          submitName="Unblock"
                          className="btn px-5 py-2 defaultbutton rounded-lg"
                          onClick={handleDisableAnnualRestriction}
                          loading={showLoader}
                        />
                      </Form.Item>
                    </Col>
                  ) : (
                    <Col sm={"auto"}>
                      <Form.Item className="m-0 cusHeight38">
                        <SubmitButton
                          ky="block"
                          type="danger"
                          submitName="Block"
                          onClick={handleEnableAnnualRestriction}
                          loading={showLoader}
                          className="btn px-5 py-2 defaultbutton rounded-lg"
                        />
                      </Form.Item>
                    </Col>
                  )}
                </Row>
              </Form>
            </SettingsPanel>

            {/* Block / Unblock Calendar Date */}
            <SettingsPanel title="Block / Unblock Calendar Date">
              <Form layout="vertical">
                <Row gutter={[16, 16]} align="bottom">
                  <Col sm={8}>
                    <Form.Item label="" className="m-0">
                      <RangePicker
                        value={selectedDate}
                        onChange={(dates) => setSelectedDate(dates || [])}
                      />
                    </Form.Item>
                  </Col>

                  {blockedDate?.status ===
                  process.env.REACT_APP_BLOCK_STATUS ? (
                    <Col sm={"auto"}>
                      <Form.Item className="m-0 cusHeight38">
                        <SubmitButton
                          ky="unblock"
                          type="danger"
                          submitName="Unblock"
                          className="btn px-5 py-2 defaultbutton rounded-lg"
                          onClick={handleDisableAnnualRestriction}
                          loading={showLoader}
                        />
                      </Form.Item>
                    </Col>
                  ) : (
                    <Col sm={"auto"}>
                      <Form.Item className="m-0 cusHeight38">
                        <SubmitButton
                          ky="block"
                          type="danger"
                          submitName="Block"
                          onClick={handleEnableAnnualRestriction}
                          loading={showLoader}
                          className="btn px-5 py-2 defaultbutton rounded-lg"
                        />
                      </Form.Item>
                    </Col>
                  )}
                </Row>
              </Form>
            </SettingsPanel>
          </div>
        )}
      </div>
    </div>
  );
}
